export default "__VITE_ASSET__BaG_G_su__"